import React from 'react';

const SvgArrowForward = () => (
  <svg viewBox="0 0 20 20" width="1em" height="1em">
    <path d="M9.3 12.3H2.7V7.7h6.5V3.4l8 6.6-8 6.6v-4.3z" fill="currentColor" />
  </svg>
);

export default SvgArrowForward;
